module.exports = __webpack_public_path__ + "img/article_c.d7d523d1.svg";